jQuery(function ($) {
    $(document).ready(function () {
        if ($(".hero-swiper").length > 0) {

            let loop = false;

            if ($(".hero-swiper").find('.swiper-slide').length > 1) {
                loop = true;
            }

            const heroSwiper = new Swiper('.hero-swiper', {
                slidesPerView: 1,
                loop: loop,
                autoplay: {
                    delay: 7000,
                },
                pagination: {
                    el: ".hero-swiper-pagination",
                    clickable: true
                },
                navigation: {
                    nextEl: ".hero-swiper-button-next",
                    prevEl: ".hero-swiper-button-prev",
                },
            });
        }
    });
});

